export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: 0,
    borderWidth: 0
  },
  overlay: {
    zIndex: 100,
    backgroundColor: 'rgba(0,0,0,0)'
  }
}

export const tagModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 20,
    width: 400
  },
  overlay: {
    zIndex: 100,
    backgroundColor: 'rgba(0,0,0,0)'
  }
}
